import { useContext } from 'react';

import { type Formatter } from '../../core/types/formatter.js';
import { getFormatter } from '../../core/utils/get-formatter.js';
import { GaugeChartFormatterContext } from '../contexts/GaugeChartFormatterContext.js';

export const useGaugeChartFormatterContext = (): Formatter => {
  const formatter = useContext(GaugeChartFormatterContext);

  return getFormatter(formatter);
};
